import React, { useContext } from "react";
import { Stack, Heading, Text } from "@chakra-ui/layout";
import { useColorModeValue } from "@chakra-ui/color-mode";
import {
  Button,
  Input,
  Flex,
  Link,
  Box,
} from "@chakra-ui/react";
import { getAccount, updateUser, getAuthUrl } from "../../utils/sessionHelper";
import { useSession } from "next-auth/react";
import { useFirebaseUser } from "../../utils/useFirebaseUser";
import toast from "react-hot-toast";
import { TweetContext } from "context/tweetContext";
import Image from "next/image";

export function Partner({ partner, index }) {

  const { data: session, status } = useSession() ?? {}
  const loading = status === "loading"

  const [refresh, refresher] = React.useState({});
  const [key, setKey] = React.useState("");
  const [hasDiscount, setHasDiscount] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const isAuthenticated = useFirebaseUser();
  const tweetContext: any = useContext(TweetContext);

  React.useEffect(() => {
    // console.log("key: " + getAccount(session)?.apiKey);
    if (isAuthenticated && !key) {
      if (partner?.id && getAccount(session)?.[partner.id]) {
        setKey(getAccount(session)?.[partner.id]);
      }
    }
  }, [isAuthenticated, refresh]);

  return (
    <Flex key={"integrations" + index} gap="4">
      {partner.image &&
        <Box w={["20px", "40px", "80px"]} minW={["20px", "40px", "80px"]} h={["20px", "40px", "80px"]} >
          <Image alt="partner" src={partner.image} width={200} height={200} />
        </Box>
      }
      <Flex
        flexDir="column"
        // spacing={2}
        ml={[0, 2, 4]}
      >
        <Heading fontSize="2xl">
          <Link isExternal href={partner.home}>
            {partner.name}
          </Link>
        </Heading>
        <Box mt={2}>{partner.desc}</Box>
        {partner?.hasInputKey && (
          <Flex mt={2}>
            <Input
              value={key}
              onChange={(e) => {
                setKey(e.target.value);
              }}
              maxW={300}
              placeholder="xxxx-xxxx-xxxx-xxxx"
            />
            <Button
              ml={2}
              variant={"primary"}
              isLoading={isLoading}
              onClick={async () => {

                if (!key || key?.includes("•")) {
                  toast.error("Api key not valid");
                  return;
                }

                setIsLoading(true);
                let dataToSave = {};
                dataToSave[partner.id] = key;
                console.log(dataToSave);
                await updateUser(session, dataToSave, false);
                setIsLoading(false);

                if (partner.id == "keyTh") {
                  toast.success("Key saved - the discount will take 24h to be applied");
                }

                tweetContext.refresher({});
              }}
            // bg="blue.100"
            // _hover={{ bg: "blue.200" }}
            // color="gray.800"
            >
              Save
            </Button>
          </Flex>
        )}
        <Button
          mt={4}
          as="a"
          // colorScheme="twitter"
          // variant="outline"
          variant="secondary"
          href={partner.link}
          target="_blank"
          maxW="200px"
        >
          {partner.ctaLabel ?? "Get this integration"}
        </Button>
      </Flex>
    </Flex>
  );
}
